import { render, staticRenderFns } from "./InvestmentsSettingsPortfolioList.vue?vue&type=template&id=0218aa5b&"
import script from "./InvestmentsSettingsPortfolioList.vue?vue&type=script&lang=js&"
export * from "./InvestmentsSettingsPortfolioList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports